import "../../style/WaitingAnimation.css";
// img
import greenVinyl from "/images/vinyle-vert.svg";

const WaitingAnimation = () => {


  return (
    <img src={greenVinyl} alt="Chargement..." className="waitingAnimation_image"/>
  );
};

export default WaitingAnimation;
